/* Research engagement uses the storefront's existing analytics/consent pipeline. */
(() => {
  if (window.fsAnimalResearchEvents) return;
  window.fsAnimalResearchEvents = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-fs-research-link]');
    if (!link) return;
    const detail = {
      event: 'animal_research_click',
      research_action: link.dataset.fsResearchLink,
      research_species: link.closest('[data-research-species]')?.dataset.researchSpecies || 'animals',
      study_id: link.closest('[data-study-id]')?.dataset.studyId || '',
      destination: new URL(link.href).pathname,
    };
    document.dispatchEvent(new CustomEvent('fs:research-click', { detail }));
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(detail);
    }
  });
})();
